var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "41px",
    viewBox: "0 0 31 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_data analytics_4072260") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accueil---Recherche---autocompletion-fact",
    transform: "translate(-1756.000000, -882.000000)",
    fill: "#232323",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-3",
    transform: "translate(1675.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_data-analytics_4072260",
    transform: "translate(81.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5,
    y: 22,
    width: 4,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11,
    y: 18,
    width: 4,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 20,
    width: 4,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 22,
    y: 16,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3674406,19 C7.12473002,19 7.73488121,18.3832539 7.73488121,17.6208305 C7.73488121,17.550034 7.70653348,17.4901293 7.69708423,17.4247788 L11.637419,14.2171545 C11.7886069,14.2756978 11.950594,14.3151804 12.1220302,14.3151804 C12.4608531,14.3151804 12.7591793,14.1790334 12.9981102,13.9734513 L16.5631749,15.2246426 C16.6900648,15.8536419 17.2165227,16.334241 17.8766199,16.334241 C18.6325594,16.334241 19.2467603,15.7161334 19.2467603,14.95371 C19.2467603,14.8897209 19.2184125,14.8366236 19.2116631,14.7739959 L23.1290497,11.6589517 C23.2856371,11.7215793 23.4543737,11.7597005 23.6325594,11.7597005 C24.3898488,11.7597005 25,11.1415929 25,10.3791695 C25,9.61674609 24.3884989,9 23.6325594,9 C22.8779698,9 22.2637689,9.61674609 22.2637689,10.3791695 C22.2637689,10.4445201 22.2921166,10.4989789 22.300216,10.5602451 L18.3801296,13.6766508 C18.2235421,13.6140231 18.0548056,13.5745405 17.8766199,13.5745405 C17.5391469,13.5745405 17.2408207,13.712049 17.0018898,13.9162696 L13.4354752,12.6664398 C13.3085853,12.0374404 12.7848272,11.5554799 12.1220302,11.5554799 C11.3660907,11.5554799 10.7545896,12.1735875 10.7545896,12.9360109 C10.7545896,13.0054459 10.7842873,13.0653506 10.7937365,13.1320626 L6.85205184,16.3383254 C6.70086393,16.2797822 6.53887689,16.2402995 6.3674406,16.2402995 C5.61015119,16.2402995 5,16.8556841 5,17.6208305 C5,18.3832539 5.61150108,19 6.3674406,19 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7214495,0 L8.47077354,0 L0,9.51332258 L0,37.72 C0,39.5279677 1.47197048,41 3.27986236,41 L27.720127,41 C29.5280189,41 31,39.5279677 31,37.72 L31,3.28 C31.0026344,1.47203226 29.5293414,0 27.7214495,0 Z M29.0730702,37.72 C29.0730702,38.4646129 28.4660312,39.0703548 27.7227721,39.0703548 L3.28118488,39.0703548 C2.5352807,39.0703548 1.93088671,38.4632903 1.93088671,37.72 L1.93088671,10.3306774 L7.91266793,10.3306774 C9.19154975,10.3306774 10.2270869,9.29509677 10.2270869,8.01616129 L10.2270869,1.92964516 L27.7214495,1.92964516 C28.4660312,1.92964516 29.0717477,2.53670968 29.0717477,3.28 L29.0717477,37.72 L29.0730702,37.72 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator);
export default __webpack_public_path__ + "static/media/indicator.b340917ec29bdf9a9e4ef687855172bc.svg";
export { ForwardRef as ReactComponent };